import styled from "styled-components"
import { useProTableOt } from "../../../utility/componentOt/controllers/ProtableOtController";
import ProtableOt from "../../../utility/componentOt/views/ProtableOt";
import { Input } from '../../../ui/input'
import { useState } from "react"
import { useItem } from '../../controllers/ItemController'
import { useLabel } from '../../controllers/LabelController'
import { Form, Radio, Button, Typography, Row, Col, ExpandableText } from './../../../ui/ot'
import { useRef } from "react";
import { useEffect } from "react";
import { useCallback } from "react";
import { useTranslation } from "react-i18next"
import dayjs from 'dayjs';

const setParamsFilter = (obj) => {
    return Object.entries(obj).reduce((all, [key, value]) => value === "" ? { ...all } : { ...all, [key]: value }, {})
}
const LabelPrint = (
    permission_level = null, 
) => {
    const { t } = useTranslation('translation');
    const i18nPrefix = "library.labelPrint."

    const [form] = Form.useForm();
    const actionRef = useRef()
    const [data, setData] = useState([])
    const [edit, setEdit] = useState(true)
const [search, setSearch] = useState({
        item_dateaccessioned_start:   dayjs().subtract(5, 'year').format('YYYY-MM-DD') ,
        item_dateaccessioned_end:   dayjs().format('YYYY-MM-DD')  ,
    })
    const {
        ItemData,
        getItemData
    } = useItem({
        onBefore: () => { },
        onFinish: () => { }
    })

    const columns = [
        {
            title: t(`${i18nPrefix}Title`),
            dataIndex: 'bib_title',
            key: 'bib_title',
            width: 200,
            render: (text, record, index) => {
                return (<ExpandableText
                    text={`${record?.bib_title || ""}${record?.bib_subtitle || ""}`}
                    maxLines={2}>
                </ExpandableText>)

            }
        },
        {
            title: t(`${i18nPrefix}Subject`) + "/" + t(`${i18nPrefix}Author`),
            dataIndex: 'bib_author',
            key: 'bib_author',
            render: (text, record, index) => {
                return (
                    <>
                        {record?.bib_title} / {record?.bib_author}
                    </>

                )
            }
        },
        {
            title: t(`${i18nPrefix}Item_type`),
            dataIndex: 'item_itype_description',
            key: 'bibitem_itemtype_description',
        },
        {
            title: t(`${i18nPrefix}Item_call_number`),
            dataIndex: 'item_itemcallnumber',
            key: 'item_itemcallnumber',
        },
        {
            title: t(`${i18nPrefix}barcode`),
            dataIndex: 'item_barcode',
            key: 'item_barcode',
        },
        {
            title: t(`${i18nPrefix}Actions`),
            dataIndex: 'action',
            key: 'action',
            render: (_, record) => (
                <Button variant="outline"
                    onClick={() => {
                        setData(pre => [...pre, record])
                    }}
                >{t(`${i18nPrefix}New_Record`)}</Button>
            )
        },
        // {
        //     title: '選取',
        //     dataIndex: 'select',
        //     key: 'select',
        //     render: () => (
        //         <Checkbox />
        //     )
        // },
    ]


    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
        transferColumnAntdToShadcn,
        transferSortAntdToShadcn
    } = useProTableOt({
        columns
    })
    useEffect(() => {
        checkAll()
    }, [])
    useEffect(() => {
            actionRef.current.onTableSearch()
        }, [search])
    return (
        <Row gutter={[8, 8]}>
            <Col span={24}>
                <Row>
                    <Col  >
                        <Typography.Title level={3} >
                            {t("library.backstage.LabelPrint.")}
                        </Typography.Title>
                    </Col>

                </Row>
            </Col>
            <Col span={24}>
                <ProtableOt
                    searchParams={{ ...search }}
                    actionRef={actionRef}
                    // showSearch={false}
                    columns={columns}
                    check={check}
                    setCheck={setCheck}
                    toolBarRender={() => {
                        return ([
                            <Col span={24}>
                                <Row gutter={[4, 4]} align={"middle"}>
                                    <Col>
                                        <Typography.P>
                                            {t(`${i18nPrefix}Date accessioned`)}:
                                        </Typography.P>
                                    </Col>
                                    <Col>
                                        <Input
                                            type="date"
                                            // granularity={"day"}
                                            // placeholder={t(`.time_start`)}
                                            format={"YYYY-MM-DD"}
                                            value={search?.item_dateaccessioned_start ? search?.item_dateaccessioned_start : ""}
                                            onChange={(e) => {
                                                setSearch((pre) => {
                                                    if (dayjs(e.target.value).isBefore(dayjs(pre?.item_dateaccessioned_end, "YYYY-MM-DD"))) {
                                                        return {
                                                            ...pre,
                                                            item_dateaccessioned_start: dayjs(e.target.value).format("YYYY-MM-DD"),
                                                        }
                                                    }
                                                    else {
                                                        return {
                                                            ...pre,
                                                            item_dateaccessioned_start: pre?.item_dateaccessioned_end,
                                                            item_dateaccessioned_end: e.target.value,
                                                        }
                                                    }

                                                })
                                            }}
                                        />
                                    </Col>
                                    <Col>
                                        <Typography.Title level={4}>
                                            ~
                                        </Typography.Title>
                                    </Col>
                                    <Col>
                                        <Input
                                            type="date"
                                            placeholder={t(`.time_end`)}
                                            format={"YYYY-MM-DD"}
                                            value={search?.item_dateaccessioned_end ? search?.item_dateaccessioned_end : ""}
                                            onChange={(e) => {
                                                setSearch((pre) => {
                                                    if ((dayjs(e.target.value)).isBefore(pre?.item_dateaccessioned_start)) {
                                                        return {
                                                            ...pre,
                                                            item_dateaccessioned_start: e.target.value,
                                                            item_dateaccessioned_end: pre?.item_dateaccessioned_start,
                                                        }
                                                    }
                                                    else {
                                                        return {
                                                            ...pre,
                                                            item_dateaccessioned_end: e.target.value,
                                                        }
                                                    }

                                                })
                                            }}
                                        />
                                    </Col>
                                    {(search?.item_dateaccessioned_start || search?.item_dateaccessioned_end) &&
                                        <Col>
                                            <Button
                                                type={"icon"}
                                                onClick={() => {
                                                    setSearch((pre) => {
                                                        return {
                                                            item_dateaccessioned_start: undefined,
                                                            item_dateaccessioned_end: undefined
                                                        }
                                                    })
                                                }}>
                                                X
                                            </Button>
                                        </Col>
                                    }
                                </Row>
                            </Col>,
                        ])
                    }}
                    request={async (params = {}, sort, filter) => {
                        // if (!form.getValues('numbers')) {
                        //     return {
                        //         data: [],
                        //         total: 0
                        //     }
                        // }
                        // setAxiosMode("get")
                        let newParams = {
                            ...search 
                        };
                        let order = setOrders(sort)
                        newParams = {
                            // ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                            ...newParams,
                            order,
                            size: params.pageSize,
                            cur_page: params.current,
                            custom_filter_value: params.keyword ?? "",
                            custom_filter_key: custom_filter_key,
                            // "categorycode": "TEST",
                        };
                        newParams = {
                            // ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                            ...newParams,
                            // [form.getValues('mode')]: form.getValues('numbers')
                        }
                        newParams = setParamsFilter({
                            ...newParams,
                        });
                        // setPageSize(params?.pageSize ?? 20)
                        return getItemData({
                            ...newParams
                        })
                    }}
                    rowSelection={false}
                />
                <LabelBatch permission_level={permission_level} edit={edit} data={data} setData={setData} />
            </Col>
        </Row>
    )
}

const LabelBatch = ({
    edit = true,
    data = [],
    setData = () => { }, 
    permission_level = null, 
}) => {
    const { t } = useTranslation('translation');
    const i18nPrefix = "library.labelPrint."
    const actionRef = useRef()
    const dataRef = useRef([])
    const columns = [
        {
            title: t(`${i18nPrefix}Title`),
            dataIndex: 'bib_title',
            key: 'bib_title',
            width: 200,
            render: (text, record, index) => {
                return (<ExpandableText
                    text={`${record?.bib_title || ""}${record?.bib_subtitle || ""}`}
                    maxLines={2}>
                </ExpandableText>)

            }
        },
        {
            title: t(`${i18nPrefix}lable_number`),
            dataIndex: 'lable_number',
            key: 'lable_number',
            render: (_, __, index) => <>{(index + 1)}</>
        },
        {
            title: t(`${i18nPrefix}Subject`) + "/" + t(`${i18nPrefix}Author`),
            dataIndex: 'bib_author',
            key: 'bib_author',
            render: (text, record, index) => {
                return (
                    <>
                        {record?.bib_title} / {record?.bib_author}
                    </>

                )
            }
        },
        {
            title: t(`${i18nPrefix}Item_type`),
            dataIndex: 'item_itype_description',
            key: 'item_itype_description',
        },
        {
            title: t(`${i18nPrefix}Item_call_number`),
            dataIndex: 'item_itemcallnumber',
            key: 'item_itemcallnumber',
        },
        {
            title: t(`${i18nPrefix}barcode`),
            dataIndex: 'item_barcode',
            key: 'item_barcode',
        },
        {
            title: t(`${i18nPrefix}Actions`),
            dataIndex: 'action',
            key: 'action',
            render: (_, record, index) => (
                <Button variant="outline"
                    onClick={() => {
                        setData(pre => pre.filter((_, filterIndex) => filterIndex !== index))
                    }}
                >{t("delete")}</Button>
            )
        },
        // {
        //     title: '選取',
        //     dataIndex: 'select',
        //     key: 'select',
        //     render: () => (
        //         <Checkbox />
        //     )
        // },
    ]
    const [loadingPrint, setLoadingPrint] = useState(false)

    const onPrintLabel = (type) => {
        let postData = {

        }
        if (type === "barcode") {
            postData = {
                type: "barcode",
                labels: data?.map((item) => {
                    return {
                        text: item?.item_barcode,
                        barcode: item?.item_barcode
                    }
                })
            }
            postLabelData(postData)
        }
        else {
            postData = {
                type: "bookback",
                labels: data?.map((item) => {
                    return {
                        text: item?.item_itemcallnumber,
                    }
                })
            }
            postLabelData(postData)
        }
    }
    const request = async (data) => await new Promise((resolve, reject) => {
        resolve({
            data: dataRef.current,
            total: dataRef.current.length
        })
    })

    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
        transferColumnAntdToShadcn,
        transferSortAntdToShadcn
    } = useProTableOt({
        columns
    })

    const {
        postLabelData
    } = useLabel({
        onBefore: ({ axiosMode }) => {
            if (axiosMode === "post") {
                setLoadingPrint(true)
            }
        },
        onFinish: ({ axiosMode }) => {
            if (axiosMode === "post") {
                setLoadingPrint(false)
            }
        }
    })
    useEffect(() => {
        console.log({ data })
        dataRef.current = data
        actionRef.current.reload()
    }, [data])
    useEffect(() => {
        checkAll()
    }, [])
    return (
        <>
            {edit && <>
                <ButtonGroup>
                    {true ?
                        permission_level?.permission_level === 1 ? 
                        <>
                            <Button variant="outline" onClick={() => onPrintLabel("barcode")} loading={loadingPrint}>{t(`${i18nPrefix}barcode_label_print`)}</Button>
                            <Button variant="outline" onClick={() => onPrintLabel("bookback")} loading={loadingPrint}>{t(`${i18nPrefix}bookcode_label_print`)}</Button>
                            {/* <Button variant="outline" >列印所選項目</Button> */}
                            <Button variant="outline" onClick={() => setData([])}>{t(`${i18nPrefix}clear_all`)}</Button>
                        </>
                        : <></>
                        :
                        <>
                            <Button variant="outline" >新增項目</Button>
                            <Button variant="outline" >儲存描述</Button>
                            <Button variant="outline" >刪除選擇項目</Button>
                            <Button variant="outline" >刪除標籤群組</Button>
                            <Button variant="outline" >刪除副本</Button>
                            <Button variant="outline" >輸出選擇項目</Button>
                            <Button variant="outline" >輸出標籤群組</Button>
                        </>
                    }
                </ButtonGroup>
                <WhiteBox>
                    <ProtableOt
                        // showMode="infiniteScroll"

                        showSearch={false}
                        actionRef={actionRef}
                        columns={columns}
                        rowSelection={false}
                        request={async (params = {}, sort, filter) => {

                            let newParams = {
                            };
                            let order = setOrders(sort)
                            newParams = {
                                // ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                                order,
                                size: params.pageSize,
                                cur_page: params.current,
                            };
                            let startIndex = (newParams?.cur_page - 1) * newParams?.size
                            let endIndex = Math.min(startIndex + newParams?.size, (dataRef.current || []).length)
                            let currentData = (dataRef.current || []).slice(startIndex, endIndex)
                            currentData = currentData.map((value, index) => {
                                return {
                                    ...value,
                                    key: (newParams?.cur_page - 1) * newParams?.size + index + 1
                                }
                            })

                            return {
                                data: currentData,
                                total: (dataRef.current || []).length
                            }
                        }}
                    // request={() => {

                    //     request(data)
                    // }}
                    />
                </WhiteBox>
            </>
            }
        </>
    )
}



const Title = styled.div`
text-align: left;
width: 100%;
font-size: 1.6em;
font-weight: 600;
`

const SubTitle = styled.div`
text-align: left;
// width: 90%;
font-size: 1.2em;
font-weight: 600;
`

const ButtonGroup = styled.div`
width: 100%;
display: flex;
gap: 1em;
align-items: flex-start;
`

const WhiteBox = styled.div`
background-color: #fff;
padding: 1em;
width: 100%;
`

const GrayText = styled.div`
color: #929292;
width: 8em;
text-align: end;
padding-right: 1em;
`

const ItemTitle = styled.div`
color: #929292;
text-align: left;
font-size: 1.1em;
font-weight: 600;
`

const ItemContainer = styled.div`
width: fit-content;
`

const ItemBox = styled.div`
padding: 0.1em;
margin-left: 1em;
/* width: fit-content; */
// border-bottom: 1px solid #d4d4d4;
display: flex;
flex-direction: row;
flex-wrap: nowrap;
align-items: center;
`

export default LabelPrint